<div class="position-relative" [class.trip-booking-package-card-container]="!tripBookingPackage.parent_trip_booking_package_id">
  <div class="p-16">
    @if (!tripBookingPackage.parent_trip_booking_package_id) {
      <trip-booking-package-header
        icon="card_travel"
        [title]="tripBookingPackage.trip_package.description"
        [showInfo]="true"
        [canDelete]="canDelete"
        [canCancel]="canCancel"
        (infoClick)="viewTripPackage()"
        (deleteClick)='deleteTripBookingPackage()'
      ></trip-booking-package-header>
    }

    @if (actualTripsMode == "open-dates") {
      <trip-package-open-date-booking-block></trip-package-open-date-booking-block>
    }

    @if (tripBookingPackage.actual_trip) {
      <div class="flex-row items-center justify-start flex-gap-16">
        @if (tripBookingPackage.actual_trip.type) {
          <div class="icon-size-24">
            @if (["going", "single"].includes(tripBookingPackage.actual_trip.type)) {
              <span class="going_trip">
                <img src="assets/icons/material-icons/filled/going_trip_icon.svg" />
              </span>
            }
            @if (["return"].includes(tripBookingPackage.actual_trip.type)) {
              <span class="return_trip">
                <img src="assets/icons/material-icons/filled/return_trip_icon.svg" />
              </span>
            }
          </div>
        }
        <div class="flex-row items-center justify-start flex-gap-16">
          <div class="actual_trip_description" [matTooltip]='tripBookingPackage.actual_trip.display_name'>{{ tripBookingPackage.actual_trip.display_name }}</div>
          <div class="date_times_trips">
            @if (tripBookingPackage.actual_trip.start_day == tripBookingPackage.actual_trip.end_day) {
              <span class="start_date_time">{{ 'il' | translate }} {{ tripBookingPackage.actual_trip.start_day | date }}</span>
            }
            @if (tripBookingPackage.actual_trip.start_day != tripBookingPackage.actual_trip.end_day) {
              <span class="start_date_time">{{ 'dal' | translate }} {{ tripBookingPackage.actual_trip.start_day | date }}</span>
              @if (tripBookingPackage.actual_trip.end_day) {
                <span class="end_date_time">{{ 'al' | translate }} {{ tripBookingPackage.actual_trip.end_day | date }}</span>
              }
            }
          </div>
        </div>
        @if (!tripBookingPackage.tour_operator_booking_ref && !tripBookingPackage.has_resale_child && actualTripsMode != "open-dates") {
          <button mat-icon-button color='accent' [matTooltip]='"Modifica partenza" | translate' (click)='editTrip()'>
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>
    }

    @if (tripBookingPackage.actual_trip && tripBookingPackage.actual_trip.meeting_point_list_id) {
      <div class="flex-row items-center justify-start flex-gap-16">
        <div class="icon-size-24">
          <img src="assets/icons/material-icons/filled/md-pin.svg"/>
        </div>
        <div class="meeting-point-description flex-row flex-wrap items-center justify-start flex-gap-4">
          <span>{{'Punto di ritrovo' | translate}}: {{meetingPointDescription}}</span>
          <span>@if (loadingMeetingPoint) {
            <mat-spinner diameter='20'></mat-spinner>
          }</span>
        </div>
        @if (!loadingMeetingPoint && actualTripsMode != "open-dates") {
          <button mat-icon-button color='accent' [matTooltip]='"Modifica punto di ritrovo" | translate' (click)='editDefaultMeetingPoint()'>
            <mat-icon>edit</mat-icon>
          </button>
        }
      </div>
    }

    @for (trip_booking_resource of tripBookingPackage.trip_booking_resources; track trip_booking_resource) {
      @if (trip_booking_resource.optional) {
        <trip-package-resource-booking
          [inputTripBookingResource]='trip_booking_resource'
        ></trip-package-resource-booking>
      }
    }
  </div>

  @for (childrenTripBookingPackage of tripBookingPackage.children_trip_booking_packages; track childrenTripBookingPackage; let first = $first; let last = $last) {
    <hr/>
    <trip-booking-package
      [tripBookingPackage]='childrenTripBookingPackage'
      [iterationData]="{is_first: first, is_last: last}"
    ></trip-booking-package>
  }

  @if (!tripBookingPackage.parent_trip_booking_package_id) {
    <div class="p-16">
      <trip-booking-package-related-buttons></trip-booking-package-related-buttons>
    </div>
  }
</div>